import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import IconContainer from "./IconContainer"

const TaskSubformIcon = ({ className = "w-8 h-8", ariaHidden = false }) => (
  <IconContainer className={className} ariaHidden={ariaHidden}>
    <SvgSpriteIcon iconName="task-subform" className="h-4/5 w-4/5" />
  </IconContainer>
)

TaskSubformIcon.propTypes = {
  className: types.string,
  ariaHidden: types.bool,
}

export default TaskSubformIcon
